import { Switch as MuiSwitch, styled, css } from "@mui/material";

export const Switch = styled(MuiSwitch)(
  ({ theme }) => css`
    .MuiSwitch-track {
      background-color: ${theme.palette.grey1[200]};
    }
    span:not(.Mui-checked) {
      .MuiSwitch-thumb {
        background-color: ${theme.palette.grey1[50]};
      }
    }
  `,
);
